import { useCallback, useState } from "react";
import useDashboardsTableHeader from "../../../hooks/useDashboardsTableHeader";
import BuildWorkflowModal from "./BuildWorkflowModal";
import ManageCustomFieldsModal from "./ManageCustomFieldsModal";
import ManageKeyPeopleTagsModal from "./ManageKeyPeopleTagsModal";
import ManageTagsModal from "./ManageTagsModal";
import ManageStatusModal from "./ManageStatusModal";
import ManageStagesModal from "./ManageStagesModal";

const ManageFieldsLoaderModal: React.FC<{
    open: boolean,
    onClose: () => void,
}> = ({ open, onClose }) => {
    const {
        manageStatusModalOpen,
        manageTagsModalOpen,
        manageStagesModalOpen,
        manageKeyPeopleTagsModalOpen,
        manageCustomFieldsModalOpen,
        manageFieldsModalOpen,
        setManageStatusModalOpen,
        setManageTagsModalOpen,
        setManageStagesModalOpen,
        setManageKeyPeopleTagsModalOpen,
        setManageCustomFieldsModalOpen,
        setManageFieldsModalOpen,
        handleEdit,
    } = useDashboardsTableHeader();
    const [field, setField] = useState<string|undefined>(undefined);

    const handleModalOpen = useCallback((field?: string) => {
        if (!!field && !field?.match(/\[\[new-(.+?)\]\]/))
            setField(field);
        else if (field?.match(/\[\[new-(.+?)\]\]/))
            setField(undefined);
        handleEdit(field);
    }, [handleEdit]);

    return (<>
        <BuildWorkflowModal open={open}
            onOpenModal={handleModalOpen}
            onClose={onClose} />
        {manageTagsModalOpen && (
            <ManageTagsModal
                open={manageTagsModalOpen}
                filterType={field}
                onClose={() => setManageTagsModalOpen(false)} />
        )}
        {manageStagesModalOpen && (
            <ManageStagesModal
                open={manageStagesModalOpen}
                onClose={() => setManageStagesModalOpen(false)} />
        )}
        {manageKeyPeopleTagsModalOpen && (
            <ManageKeyPeopleTagsModal
                open={manageKeyPeopleTagsModalOpen}
                onClose={() => setManageKeyPeopleTagsModalOpen(false)} />
        )}
        {manageCustomFieldsModalOpen && (
            <ManageCustomFieldsModal
                open={manageCustomFieldsModalOpen}
                filterType={field}
                onClose={() => setManageCustomFieldsModalOpen(false)} />
        )}
        {manageStatusModalOpen && (
            <ManageStatusModal
                open={manageStatusModalOpen}
                onClose={() => setManageStatusModalOpen(false)} />
        )}
        {manageFieldsModalOpen && (
            <ManageFieldsLoaderModal
                open={manageFieldsModalOpen}
                onClose={() => setManageFieldsModalOpen(false)} />
        )}
    </>);
}

export default ManageFieldsLoaderModal;